export default __webpack_public_path__ + "860b66586ee2ed8b1e338783442da57b.png";